export const getLanguage = () => {
  // Always return 'ltr' since we only support English now
  return "ltr";
};
export const getModule = () => {
  if (typeof window !== "undefined") {
    return JSON.parse(window.localStorage.getItem("module"));
  }
};
